import React, { useCallback, useRef, useState } from 'react';
import ListHeader from '../../common/list/ListHeader';
import NavigationPagination from '../../common/NavigationPagination';
import PeriodFilter from "../../common/filters/Period";
import StatusFilter from "../../common/filters/Status";
import ListActions from '../../common/list/ListActions';
import { useGetMaillingRulesQuery } from '../../../services/api/repositories/MaillingRuleRepository';
import TableMaillingsRules from './TableMaillingsRules';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export default function MailingRulesSection() {

    const navigate = useNavigate();

    const [currentPage, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const [dateRange, setDateRange] = useState<[Date|null, Date|null]>([null, null]);
    const [dateStart, setDateStart] = useState('');
    const [dateEnd, setDateEnd] = useState('');
    const [status, setStatus] = useState<string>('all');
    const [name, setName] = useState<string>('');
    const statusRef = useRef<HTMLSelectElement>(null);
    const nameRef = useRef<HTMLInputElement>(null);

    const {data, isLoading, isFetching, refetch} = useGetMaillingRulesQuery(
        {
            page: currentPage,
            per_page: perPage,
            date_start: dateStart,
            date_end: dateEnd,
            status: status,
            name: name,
        }
    );

    const hasSearchParametersChanged = useCallback(() => {
        if (statusRef.current?.value !== status || nameRef.current?.value !== name ) {
            return true;
        }

        if(dateRange[0] === null && dateStart !== '') {
            return true;
        }

        if(dateRange[1] === null && dateEnd !== '') {
            return true;
        }


        if(dateRange[0] !==null && dateStart !== `${dateRange[0].toLocaleDateString()} 00:00:00`){
            return true;
        }

        if(dateRange[1] !==null && dateEnd !== `${dateRange[1].toLocaleDateString()} 23:59:59`){
            return true;
        }

        return false;
    }, [dateRange, dateEnd, dateStart, status, name]);
    
    const handleSubmit = useCallback(() => {
        if(!hasSearchParametersChanged()) {
            refetch();
            return;
        }

        setStatus(statusRef.current?.value || 'all');
        setName(nameRef.current?.value || '');

        if(dateRange[0] !== null) {
            setDateStart(`${dateRange[0].toLocaleDateString()} 00:00:00`);
        } else {
            setDateStart('');
        }

        if(dateRange[1] !== null) {
            setDateEnd(`${dateRange[1].toLocaleDateString()} 23:59:59`);
        } else {
            setDateEnd('');
        }
    }, [refetch, dateRange, hasSearchParametersChanged]);

    const handleReset = useCallback(() => {
        statusRef.current!.value = 'all';
        nameRef.current!.value = '';
        setDateRange([null, null]);

        setStatus('all');
        setName('');
        setDateStart('');
        setDateEnd('');
    }, []);

    const handleAction = useCallback(() => {
        navigate('/mailing-rules/new');
    }, [navigate]);

    return (
        <>
            <ListHeader 
                actions={
                    <ListActions
                        classAction='btn-add'
                        title="Créer une configuration d'envoi"
                        textButton="Créer une configuration d'envoi"
                        handleAction={handleAction}
                    />
                }
                handleSubmit={handleSubmit}
                handleReset={handleReset}
            >
                <div className="search">
                <Form.Group className="form-group search-name">
                    <Form.Label>
                        <span className="icon"></span>
                        Nom
                    </Form.Label>
                    <Form.Control
                        type="text"
                        id="search-name-input"
                        tabIndex={1}
                        placeholder="Ex: CGV, Campagne, etc."
                        ref={nameRef}
                    />
                </Form.Group>
                </div>
                <div className="filters">
                    <PeriodFilter tabIndex={2} dateRange={dateRange} setDateRange={setDateRange}/>
                    <StatusFilter tabIndex={3} ref={statusRef}/>
                </div>
            </ListHeader>

            {(isLoading || isFetching) && <p>Chargement...</p>}
            
            {((!isLoading && !isFetching) && data !== undefined) && (
                <>
                    {("message" in data) && <p>{data.message}</p>}
                    {("total" in data) && 
                    (<>
                        <TableMaillingsRules data={data} />
                        <NavigationPagination currentPage={currentPage} lastPage={data.last_page} setPage={setPage} perPage={perPage} setPerPage={setPerPage} />         
                    </>)}
                </>
                )
            }

            {((!isLoading && !isFetching) && data === undefined) && 
                <p>Une erreur a été rencontrée.</p>
            } 
        </>
    );
}